import { render, staticRenderFns } from "./GasAlarmDetector.vue?vue&type=template&id=3e7ba539&scoped=true"
import script from "./GasAlarmDetector.vue?vue&type=script&lang=js"
export * from "./GasAlarmDetector.vue?vue&type=script&lang=js"
import style0 from "./GasAlarmDetector.vue?vue&type=style&index=0&id=3e7ba539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7ba539",
  null
  
)

export default component.exports